import { Controller } from "@hotwired/stimulus";

/**
 * フォーム送信ボタンの制御コントローラー
 *
 * 責任範囲:
 * - チェックボックスの状態に応じて送信ボタンのdisabled属性を切り替え
 * - ページロード時に初期状態を設定（チェックされていない場合はボタンを無効化）
 *
 * 使用例:
 * - 利用規約同意チェックボックスと送信ボタンの連動
 */
export class FormTermController extends Controller {
  static targets = ['button', 'checkbox']

  /**
   * 初期化
   * トリガー: コントローラーがDOMに接続された時
   * 動作: チェックボックスの現在の状態に応じてボタンの初期状態を設定
   */
  connect() {
    // チェックボックスが存在する場合のみ初期化
    if (this.hasCheckboxTarget) {
      this.buttonTarget.disabled = !this.checkboxTarget.checked;
    }
  }

  /**
   * チェックボックスの状態変更時の処理
   * トリガー: チェックボックスのchangeイベント
   * 動作: チェックされた場合はボタンを有効化、チェックが外れた場合は無効化
   */
  toggleCheck(event) {
    this.buttonTarget.disabled = !event.target.checked;
  }
}
